import { MenuItem } from "@mui/material";
import { MenuItemDef, IMenuActionParams } from "ag-grid-enterprise";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { success } from "../../../utils/AppUtils";
import store from "../../../store";
import { uiActions } from "../../../reducers/uiReducer";
import { updateJourneyUATStatus } from "../../../config/axios/apis/journey/journey";

interface IProps {
    selectedRows: any[];
    action: VoidFunction;
}

const UATJourneyActions = {
    setUat: (selectedItems) =>
        ({
            name: "Set as UAT",

            action: () => {
                const setIds = selectedItems.map((item) => item.id);

                return updateJourneyUATStatus({ idsToSet: setIds, idsToUnset: [] }, {}, true).then(() => {
                    store.dispatch(uiActions.setForceRefreshGrid(true));
                    success(<FormattedMessage id="grid.message.uat-status-updated" defaultMessage="Updated UAT status" />);
                });
            },
        }) as MenuItemDef,
    removeUat: (selectedItems) =>
        ({
            name: "Set as not UAT",

            action: () => {
                const setIds = selectedItems.map((item) => item.id);

                return updateJourneyUATStatus({ idsToSet: [], idsToUnset: setIds }, {}, true).then(() => {
                    store.dispatch(uiActions.setForceRefreshGrid(true));
                    success(<FormattedMessage id="grid.message.uat-status-updated" defaultMessage="Updated UAT status" />);
                });
            },
        }) as MenuItemDef,
};

export const getUATJourneyMenuItemsDefinition = (selectedRows: any[]): MenuItemDef[] => {
    // NOTE: Used from the context menu. getSelectedRows() will return checked rows (the checkbox).
    // We can grab the data by using params.node.data...

    // const selectedRows = params.api.getSelectedRows();

    // if (selectedRows.length === 0) {
    //     params.node?.setSelected(true);
    //     selectedRows.push(...params.api.getSelectedRows());
    // }

    // if (selectedRows.length === 1 && !params.node?.isSelected()) {
    //     params.api.deselectAll();
    //     params.node?.setSelected(true);
    //     selectedRows.splice(0, 1, ...params.api.getSelectedRows());
    // }

    const UATJourneys = selectedRows.filter((e) => e?.isUat === true);
    const regularJourneys = selectedRows.filter((e) => e?.isUat === false);

    if (UATJourneys.length !== 0 && UATJourneys.length === selectedRows.length) {
        return [UATJourneyActions.removeUat(UATJourneys)];
    }

    if (regularJourneys.length !== 0 && regularJourneys.length === selectedRows.length) {
        return [UATJourneyActions.setUat(regularJourneys)];
    }

    return [];
};

// dirty fix on the {} as IMenuActionParams arg: irrelevant because params are not read; needed since
// the same methods are called from the grid RMB click context menu.
const buildMenuClickHandler = (config: MenuItemDef, parentAction: VoidFunction) => () => {
    if (config.action) {
        config.action({} as IMenuActionParams);
    }
    parentAction();
};

export const GetUATJourneyMenuItemNodes: FC<IProps> = ({ selectedRows, action }) => {
    const UATJourneys = selectedRows.filter((e) => e?.isUat === true);
    const regularJourneys = selectedRows.filter((e) => e?.isUat === false);

    if (UATJourneys.length !== 0 && UATJourneys.length === selectedRows.length) {
        const config = UATJourneyActions.removeUat(UATJourneys);
        return <MenuItem onClick={buildMenuClickHandler(config, action)}>{config.name}</MenuItem>;
    }

    if (regularJourneys.length !== 0 && regularJourneys.length === selectedRows.length) {
        const config = UATJourneyActions.setUat(regularJourneys);
        return <MenuItem onClick={buildMenuClickHandler(config, action)}>{config.name}</MenuItem>;
    }

    return null;
};
